(function (factory) {
	var moduleName = "ccsCampaignBanner";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName,
			[
				"ccsJq",
				"ccsCampaignBannerListener",
				"fancybox"
			],
			factory);
		return;
	}

	var moduleExport = factory(ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	var browsers = {
		ie: "msie",
		chrome: "chrome",
		opera: "opera",
		safari: "safari",
		mozilla: "mozilla"
	};

	var postMessages = {
		openMicrositeRequest: "openMicrositeRequest"
	};

	var bannerContentType = {
		html: "html",
		image: "image"
	};

	var displayMode = {
		lightbox: "lightbox",
		popup: "popup"
	};

	var defaults = {
		campaignData: {
			fallbackEvent: "from server",
			imageBanner: {
				id: "from server",
				url: "from server",
				width: "from server",
				height: "from server",
				type: "from server",
				onClickLogEvent: "from server"
			},
			htmlBanner: {
				id: "from server",
				url: "from server",
				width: "from server",
				height: "from server",
				type: "from server",
				onClickLogEvent: "from server",
				domain: "from server"
			},
			microsite: {
				url: "from server",
				displayMode: "from-server",
				width: "from server",
				height: "from server"
			}
		}
	};

	function parseEvent(eventJson) {
		if (!eventJson)
			return null;

		return $.parseJSON(eventJson);
	}

	function dispatchEvent(logEvent) {
		if (!logEvent)
			return;

		var eventData = parseEvent(logEvent);

		if (!eventData)
			return;

		var logFunction = window[eventData.logFunctionName];

		if (!logFunction)
			return;

		logFunction(eventData.eventId);
	}

	function showPopup(width, height, url) {
		window.open(
			url,
			"_blank",
			"width=" + width +", " +
			"height=" + height + ", " +
			"location=no," +
			"menubar=no," +
			"resizable=yes," +
			"scrollbars=yes," +
			"status=no," +
			"toolbar=no");
	}

	function showLightBox(width, height, url) {
		$.fancybox({
			href: url,
			type: "iframe",
			width: width,
			height: height,
			padding: 10,
			openSpeed: 200,
			closeSpeed: 100,
			helpers: { title: null, overlay: { closeClick: false } },
			iframe: { preload: false }
		});
	}

	function getBannerById(id) {
		return $.grep(
			ccsCampaignBanner.registeredBanners,
			function(item) { return item.id && item.id === id; })[0];
	}

	function showMicrosite(microsite) {
		if (microsite.displayMode === displayMode.lightbox) {
			showLightBox(microsite.width, microsite.height, microsite.url);
		}

		if (microsite.displayMode === displayMode.popup) {
			showPopup(microsite.width, microsite.height, microsite.url);
		}
	}

	function onBannerClick(bannerId) {
		var banner = getBannerById(bannerId);

		dispatchEvent(banner.onClickLogEvent);
		showMicrosite(banner.microsite);
	}

	function registerBanner(banner) {
		if (!banner && !banner.id)
			return;

		if (getBannerById(banner.id))
			return;

		ccsCampaignBanner.registeredBanners.push(banner);
	}

	function getCurrentBrowser() {
		var ua = navigator.userAgent;

		ua = ua.toLowerCase();

		var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
			/(webkit)[ \/]([\w.]+)/.exec(ua) ||
			/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
			/(msie) ([\w.]+)/.exec(ua) ||
			ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
			[];

		var matched = {
			browser: match[1] || "",
			version: match[2] || "0"
		};

		var browser = {};

		if (matched.browser) {
			// Chrome is Webkit, but Webkit is also Safari.
			if (matched.browser !== browsers.chrome && matched.browser === "webkit") {
				browser.name = browsers.safari;
				browser.version = matched.version;
			} else {
				browser.name = matched.browser;
				browser.version = matched.version;
			}
		}

		return browser;
	};

	function isCompatibleBrowser() {
		var currentBrowser = getCurrentBrowser();

		var uncompatibleBrowsers = [
			{ name: browsers.ie, version: "9.0" },
			{ name: browsers.ie, version: "8.0" },
			{ name: browsers.ie, version: "7.0" },
			{ name: browsers.ie, version: "6.0" },
			{ name: browsers.ie, version: "5.0" }
		];

		var findedUncompatibleBrowsers = $.grep(uncompatibleBrowsers,
			function(item) {
				return item.name === currentBrowser.name && item.version === currentBrowser.version;
			});

		return findedUncompatibleBrowsers.length === 0;
	}

	function selectBanner(campaignData) {
		var isCompatible = isCompatibleBrowser();

		if (!isCompatible)
			dispatchEvent(campaignData.fallbackEvent);

		return isCompatible
			? campaignData.htmlBanner || campaignData.imageBanner
			: campaignData.imageBanner || campaignData.htmlBanner;
	}

	function buildCampaignBanner(banner) {
		var $bannerContainer = $("#" + banner.id);

		if (banner.type === bannerContentType.html) {
			$bannerContainer.css({
				height: banner.height + "px",
				maxWidth: banner.width + "px"
			});

			var $bannerIframe = $("<iframe scrolling=\"no\" frameBorder=\"0\"></iframe>")
				.attr("src", banner.url)
				/*CSS hack for mobile safari since it ignores the width and height of iframe*/
				.css({
					width: "1px",
					minWidth: "100%",
					height: "1px",
					minHeight: "100%"
				});

			$bannerContainer.append($bannerIframe);

			window.ccsCampaignBannerListener.addTrustedDomain(banner.domain);
			window.ccsCampaignBannerListener.registerHandler(banner.id, postMessages.openMicrositeRequest, onBannerClick);
		}

		if (banner.type === bannerContentType.image) {

			var $bannerLink = $("<a style=\"cursor: pointer;\"></a>");
			var $bannerImgContent = $("<img src=\"" + banner.url + "\" alt=\"\" style=\"border: 0;\" />");
			$bannerLink.append($bannerImgContent);
			$bannerContainer.append($bannerLink);

			$bannerLink.click(function () {
				onBannerClick(banner.id);
			});
		}
	}

	function ccsCampaignBanner(options) {
		var o = $.extend(true, {}, defaults, options);

		var selectedBanner = selectBanner(o.campaignData);

		if (!selectedBanner)
			return;

		registerBanner(selectedBanner);

		buildCampaignBanner(selectedBanner);
	}

	ccsCampaignBanner.registeredBanners = [];
	window.ccsCampaignBanner = window.ccsCampaignBanner || ccsCampaignBanner;
}));

(function (factory) {
	var moduleName = "ccsCampaignBannerListener";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["ccsJq"], factory);
		return;
	}

	var moduleExport = factory(ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	if (!window.postMessage)
		return;

	var campaignBannerListener = (function () {
		function messageHandler(event) {
			if (!window.ccsCampaignBannerListener.isInTrusted(event.origin))
				return;
			var msg = event.data;

			var isMessageReceived = true;
			var data;

			try {
				data = $.parseJSON(msg);

				var isOpenMicrositeRequest = data.messageType && data.messageType === "openMicrositeRequest";

				if (!data.messageId || !data.params || !isOpenMicrositeRequest)
					isMessageReceived = false;
			} catch (e) {
				isMessageReceived = false;
			}

			if (isMessageReceived) {
				var handlers = $.grep(
					window.ccsCampaignBannerListener.registeredHandlers,
					function (handler) {
						return handler.type && handler.type === data.messageType &&
								handler.id && handler.id === data.messageId;
					});

				if (!handlers)
					return;

				$.each(handlers, function (index, handler) {
					if ($.isFunction(handler.callback)) {
						handler.callback(data.params);
					}
				});
			}
		};

		function ctr() {
			this.trustedDomains = [];
			this.registeredHandlers = [];

			if (window.addEventListener) {
				window.addEventListener("message", messageHandler, false);
			} else {
				window.attachEvent("onmessage", messageHandler);
			}
		}

		ctr.prototype.addTrustedDomain = function (domain) {
			if (this.isInTrusted(domain))
				return;

			this.trustedDomains.push(domain);
		};

		ctr.prototype.isInTrusted = function (domain) {
			return $.inArray(domain, this.trustedDomains) !== -1;
		};
		ctr.prototype.registerHandler = function (id, messageType, messageHanleCallback) {
			var handler = { id: id, type: messageType, callback: messageHanleCallback };
			this.registeredHandlers.push(handler);
		};
		return ctr;
	}());

	window.ccsCampaignBannerListener = window.ccsCampaignBannerListener || new campaignBannerListener();
}));
